"use client";

import Link from "next/link";
import Image from "next/image";
import { useTheme } from "@/app/lib/context/ThemeContext";

export default function LogoLink() {
  const { theme, mounted } = useTheme();
  const isDark = mounted && theme === "dark";

  return (
    <Link
      href="/"
      className="relative block h-[80px] w-[160px] lg:w-[200px] rounded-sm shrink-0"
    >
      <span
        aria-hidden="true"
        className="absolute inset-0 bg-gradient-purple rounded-sm transition-opacity duration-500"
        style={{ opacity: isDark ? 0 : 1 }}
      />
      <Image
        src="/logo-min-v2.png"
        fill
        priority
        sizes="(max-width: 1024px) 160px, 200px"
        alt="EconChangers LLC Logo"
        className="object-contain"
      />
    </Link>
  );
}
